export default function filterRecentlyVisitedForWhitelabel(
  regions: any[],
  isWhitelabel: boolean,
  partner_id?: string,
): any[] {
  const partnerIdNum = Number(partner_id);

  return regions.filter((region) => {
    const isWhitelabelRegion = region?.is_whitelabel_region === true;
    const partnerIds = region?.whitelabel_partner_ids;

    if (isWhitelabel) {
      if (!isWhitelabelRegion) {
        return true;
      }
      return Array.isArray(partnerIds) && partnerIds.includes(partnerIdNum);
    }
    return !isWhitelabelRegion;
  });
}

export function isWhitelabelPartnerInventoryFunc(propertyData: any, partner_id?: any): any {
  if (!propertyData || !partner_id) return false;

  if (propertyData?.parent) {
    return (
      propertyData.parent?.is_whitelabel_inventory === true &&
      propertyData?.parent.whitelabel_partner_ids?.includes(partner_id)
    );
  }
  return (
    propertyData?.is_whitelabel_inventory === true &&
    propertyData?.whitelabel_partner_ids?.includes(partner_id)
  );
}
